import {clsx} from 'clsx';
import React, {useCallback} from 'react';

import {usePanelSearchDebouncedContext} from '../../state/panelbank/PanelSearchContextProvider';
import {type PlotFontSize} from '../../util/plotHelpers/plotFontSize';
import {TruncateTextTooltip} from '../common/TruncateText/TruncateTextTooltip';
import {TruncationType} from '../common/TruncateText/TruncateTextTypes';
import {usePanelContext} from '../Panel/PanelContextProvider';
import {PanelPopupMode} from '../Panel/types';

interface PanelTitleProps {
  title: string;
  fontSize?: PlotFontSize | 'auto';
  disallowSelect?: boolean;
}

export const PanelTitle: React.FC<PanelTitleProps> = ({
  title,
  fontSize,
  disallowSelect,
}) => {
  const {makeHighlightSearchTitle} = usePanelSearchDebouncedContext();
  const {setPanelPopupMode} = usePanelContext();

  const handleClick = useCallback(() => {
    setPanelPopupMode(PanelPopupMode.EDIT);
  }, [setPanelPopupMode]);

  return (
    <TruncateTextTooltip
      className={clsx('PanelTitle', fontSize, {
        'select-none': disallowSelect,
      })}
      truncationType={TruncationType.Middle}
      fullText={title}
      highlight={makeHighlightSearchTitle}
      onClick={handleClick}
      noLink>
      title
    </TruncateTextTooltip>
  );
};
